import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../../utils/axios";

const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchAmazonVendorTermPoolList = createAsyncThunk(
  "amazonvendor/fetchAmazonVendorTermPoolList",
  async () => {
    const response = await axiosInstance.request({
      url: `/preferences/amazonvendor/term_pools`,
      method: `GET`,
    });
    return response;
  }
);

const amazonVendorTermPoolListSlice = createSlice({
  name: "amazonvendor",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAmazonVendorTermPoolList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAmazonVendorTermPoolList.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchAmazonVendorTermPoolList.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const AmazonVendorTermPoolListReducer = amazonVendorTermPoolListSlice.reducer;

export default AmazonVendorTermPoolListReducer;

export const amazonVendorTermPoolListAction = amazonVendorTermPoolListSlice.actions;
